const showAlert = ref(false);

export const useAlert = () => {
  let alertTimer: any;

  const resetAlert = () => {
    if (alertTimer) {
      clearTimeout(alertTimer);
      showAlert.value = false;
    }
  };

  const setAlert = ({ duration } = { duration: 5000 }) => {
    resetAlert();
    showAlert.value = true;
    alertTimer = setTimeout(() => {
      showAlert.value = false;
    }, duration);
  };

  return {
    showAlert: computed(() => showAlert.value),
    resetAlert,
    setAlert,
  };
};
